import React from 'react';
import {
  Box,
  ToggleButtonGroup,
  ToggleButton,
  Tooltip,
  IconButton
} from '@mui/material';
import {
  SentimentSatisfiedAlt as PositiveIcon,
  SentimentNeutral as NeutralIcon,
  SentimentVeryDissatisfied as NegativeIcon
} from '@mui/icons-material';
import { colors } from '../../design-system/tokens';

const SentimentSelector = ({ value, onChange, size = 'medium' }) => {
  const handleChange = (event, newValue) => {
    if (newValue !== null) {
      onChange(newValue);
    }
  };

  const handleIconClick = (sentiment) => {
    onChange(sentiment);
  };

  // Versão "large" para modals - ícones maiores sem bordas
  if (size === 'large') {
    const sentiments = [
      { value: 'positive', label: 'Positivo', color: colors.sentiment.positive.main, Icon: PositiveIcon },
      { value: 'neutral', label: 'Neutro', color: colors.sentiment.neutral.main, Icon: NeutralIcon },
      { value: 'negative', label: 'Negativo', color: colors.sentiment.negative.main, Icon: NegativeIcon }
    ];

    return (
      <Box sx={{ display: 'flex', gap: 3, justifyContent: 'center' }}>
        {sentiments.map(({ value: sentValue, label, color, Icon }) => (
          <Tooltip key={sentValue} title={label}>
            <IconButton
              onClick={() => handleIconClick(sentValue)}
              sx={{
                p: 2,
                transition: 'all 0.2s ease',
                transform: value === sentValue ? 'scale(1.2)' : 'scale(1)',
                bgcolor: value === sentValue ? `${color}15` : 'transparent',
                '&:hover': {
                  bgcolor: `${color}25`,
                  transform: 'scale(1.15)'
                }
              }}
            >
              <Icon
                sx={{
                  fontSize: 36,
                  color: color,
                  opacity: value === sentValue ? 1 : 0.6
                }}
              />
            </IconButton>
          </Tooltip>
        ))}
      </Box>
    );
  }

  // Versão padrão com ToggleButtonGroup
  return (
    <Box>
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={handleChange}
        aria-label="sentimento do artigo"
        size={size}
      >
        <Tooltip title="Positivo">
          <ToggleButton value="positive" aria-label="positivo">
            <PositiveIcon sx={{ color: colors.sentiment.positive.main }} />
          </ToggleButton>
        </Tooltip>
        <Tooltip title="Neutro">
          <ToggleButton value="neutral" aria-label="neutro">
            <NeutralIcon sx={{ color: colors.sentiment.neutral.main }} />
          </ToggleButton>
        </Tooltip>
        <Tooltip title="Negativo">
          <ToggleButton value="negative" aria-label="negativo">
            <NegativeIcon sx={{ color: colors.sentiment.negative.main }} />
          </ToggleButton>
        </Tooltip>
      </ToggleButtonGroup>
    </Box>
  );
};

export default SentimentSelector;